const invalidLegalBusinessNames = new Set([
  "llc",
  "gmbh",
  "sarl",
  "srl",
  "ltd",
  "sas",
  "sa",
  "bv",
  "inc",
  "n/a",
  "na",
  "none",
  "etc",
]);

export const isValidLegalBusinessName = (value: string | undefined): boolean =>
  !value || !invalidLegalBusinessNames.has(value.trim().toLowerCase().replace(/\./g, ""));
